<template>
  <div class="payment-box">
    <div class="payment-top">
      <div>{{ $t('total_payment') }}</div>
      <div class="t-right">Rp {{ amount | fenToYanAndFormat }}</div>
    </div>

    <div class="has-padding payment-mid">
      <div>
        <div>
          <div style="padding-top: 20px;">
            <p>{{ $t('bank') }}</p>
            <md-input-item
              v-model="bankName"
              readonly
              is-title-latent
              :placeholder="$t('bank')"
              @focus="isBankSelectorShow = true"
            >
              <img
                v-if="bankNo"
                slot="left"
                class="icon_svg"
                :src="getIconByCode(bankNo)"
                alt="bank-icon"
              >
            </md-input-item>
          </div>

          <div class="mid-word">{{ $t('Virtural Account No:') }}:</div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 20px; border-bottom: 1px solid #dedfe0; padding-bottom: 20px;">
            <div class="num">{{ $route.query.ref1 }}</div>
            <div class="t-right">
              <Copy :text="$route.query.ref1" />
            </div>
          </div>
        </div>

        <md-tabs v-model="activeNames">
          <md-tab-pane label="mBanking" name="2">
            <div class="list-tip">
              {{ $t('1.⁠ ⁠Access Mobile Banking via your mobile phone.') }}
            </div>
            <div class="list-tip">
              {{ $t('2.⁠ ⁠Select the Transfer menu,⁠Select Virtual Account Billing, then choose the debit account.') }}
            </div>
            <div class="list-tip">
              {{ $t('3.⁠ ⁠Enter your Virtual Account number in the New Input menu.') }}
            </div>
            <div class="list-tip">
              {{ $t('4.⁠ ⁠The bill amount and virtual account name will appear on the confirmation screen.') }}
            </div>
            <div class="list-tip">
              {{ $t('5.⁠ ⁠Confirm the transaction and Initiate a transfer request.') }}
            </div>
            <div class="list-tip">
              {{ $t('6.⁠ ⁠Your payment has been successfully completed.') }}
            </div>
          </md-tab-pane>
        </md-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Copy from '@/components/Copy'
import { fenToYanAndFormat } from '@/utils/format-amount'
import { Tabs, TabPane, Button, InputItem } from 'mand-mobile'
import { getIconByCode } from '@flash/fin-logo'

// 支付结果 查询
export default {
  name: 'PaymentInfo',
  components: {
    Copy,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [InputItem.name]: InputItem,
    [TabPane.name]: TabPane
  },
  filters: {
    fenToYanAndFormat
  },
  data () {
    return {
      getIconByCode,
      activeNames: ''
    }
  },
  computed: {
    bankNo () {
      return this.$route.query?.bankNo || ''
    },
    bankName () {
      return this.$route.query?.bankName || ''
    },
    amount () {
      return this.$route.query?.amount || ''
    }
  },
  methods: {
    bankToMerchant () {
      window.location.href = '/goods/id-goods'
    }
  }
}
</script>

<style scoped lang="scss">
.action-header {
  border-top: 1px solid #b2b2b2;
  border-bottom: 1px solid #b2b2b2;
  padding: 10px 0;
  margin-top: 20px;
}

.bac-logo {
  margin-right: 12px;
  height: 32px;
}

.icon_svg {
  width: 64px;
  height: 64px;
  border-radius: 50%;
}

.payment-box {
  padding: 20px;

  .has-padding {
    padding: 30px;
  }

  .payment-top {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    padding: 20px;
    font-size: 32px;
    font-weight: 500;
  }

  .virtual-account {
    display: flex;
    justify-content: space-between;
  }

  .t-right {
    text-align: right;
  }

  .payment-mid {
    font-size: 28px;
    border-top: 1px solid #dedfe0;

    .mid-word {
      padding: 30px 0;
      opacity: 0.5;
    }
  }

  .list-tip {
    padding: 10px 0;
  }

  .num {
    color: #ff4d4f;
  }

  .back-merchant {
    width: 100%;
    position: absolute;
    bottom: 60px;
    left: 0;
    padding: 0 30px;
  }
}
</style>
